import { call, delay, put } from 'redux-saga/effects';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';
import { loadHostListBegin, loadHostListFailed, loadHostListSuccessful } from '../actions';

export default function* loadHostList(action) {
  try {
    const {
      payload: {
        page = 1,
        limit = DEFAULT_ITEMS_OF_PAGE,
        filter,
        sort = '',
        metricKeys = null,
      } = {},
    } = action;
    const url = `${BACKEND_URL}/hosts`;
    filter.type = 1;
    const pool = {
      page,
      limit,
    };
    if (metricKeys) {
      pool.select_metric_keys = metricKeys;
    }
    if (filter && Object.keys(filter).length) {
      pool.filter = filter;
    }
    if (sort && sort.length) {
      pool.sort = sort;
    }
    yield delay(LOADING_DELAY);
    yield put(loadHostListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadHostListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadHostListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadHostListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
